import React from 'react';
import './PortfolioItem.css';

import { FaCameraRetro, FaLink } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Import PhotoView from react-photo-view
import { PhotoView } from 'react-photo-view';



const PortfolioItem = (props) => {

  // Destructuring props
  const { id, image, title, category, portfolio, className } = props;

  return (
    <div className={`portfolio-item ${className}`} key={id}>
      <div className="portfolio-content">

        {/* Portfolio Image */}
        <img src={image} alt={title} />

        {/* Portfolio Content */}
        <div className='content'>

          <div className='btn-container'>

            {/* Plus icon for lightbox */}
            <PhotoView src={image}>
              <div className='view'>
                <div className='icon'><FaCameraRetro /></div>
              </div>
            </PhotoView>

            {/* Link to the individual Portfolio Detail Page */}
            <Link
              to={{
                pathname: '/Portfolio/' + title,
              }}
              state={portfolio}
              className='icon'
            >
              <FaLink />
            </Link>

          </div>

          {/* Link to the individual Portfolio Detail Page */}
          <Link
            to={{
              pathname: '/Portfolio/' + title,
            }}
            state={portfolio}
          >
            <h4>{title}</h4> {/* Portfolio Title */}
          </Link>

          {/* Portfolio Category */}
          <h6>{category}</h6>

        </div>

      </div>
    </div>
  );
};

export default PortfolioItem;